/**
 * A Train card, opened.
 *
 * The card id is in the query so a drill can be linked to — from the tab, from a Learn
 * page's "try it", from the hand-end verdict when Phase 5 writes it. Everything else is
 * the trainer exactly as it is; this phase re-fronts it and does not restyle it.
 */
import { useSearchParams } from "react-router-dom";
import { Train } from "../routes/Train";
import { TRAIN_CARDS } from "./poker-cards";

export function TrainRun({ build }: { build?: boolean }) {
  const [params] = useSearchParams();
  if (build) return <Train />;
  const card = TRAIN_CARDS.find((c) => c.id === params.get("card"));
  return <Train preset={card?.preset} />;
}
